module.exports = __webpack_public_path__ + "img/PG.8d013737.png";